import { useImperativeHandle } from 'react';

export default ({ onAvatarClick, refForwarded, children }) => {
    useImperativeHandle(refForwarded, () => ({
        openAvatarModal() {
            onAvatarClick();
        },
    }));

    return children;
};
